export const ACTION = {
    GET_NAV_CONTENT: 'GET_NAV_CONTENT',
    GET_DIVIDEND_CONTENT: 'GET_DIVIDEND_CONTENT',
    GET_NAV_FUND_FILTER:'GET_NAV_FUND_FILTER',
    GET_HISTORIC_DATA_DIVIDEND:'GET_HISTORIC_DATA_DIVIDEND',
    GET_HISTORIC_DATA_NAV:'GET_HISTORIC_DATA_NAV',
    GET_DIVIDEND_SEARCH_CONTENT:'GET_DIVIDEND_SEARCH_CONTENT',
    GET_NAV_SEARCH_CONTENT:'GET_NAV_SEARCH_CONTENT',
    GET_HISTORIC_DATA_LOADING:'GET_HISTORIC_DATA_LOADING',
};

